import React, { useEffect, useState } from 'react';
import { reduxForm, change, submit } from 'redux-form';
import { Field } from 'redux-form';
import { connect, useDispatch } from 'react-redux';
import { DateAndTimePicker, Textarea, AutoCompleteSelect, DatePicker } from '../../../../itrust_common/components/form';
import { getTemplateSupportedField } from '../../../../itrust_common/components/HelperFunctions';
import { examEdit, examLoad, examTemplateSwitched } from '../../../../redux/actions/exam/examActions';
import DisabledLoader from '../../../../other/DisabledLoader';
import { tabChange } from '../../../../itrust_common/redux/actions/otherActions';
import { required } from '../../../../itrust_common/components/form/FormValidations';
import DateFormatView from '../../../../itrust_common/components/others/DateFormatView';
import AutoCodeChiefComplaint from './AutoCodeChiefComplaint';
import ExamPatientInfo from './ExamPatientInfo';
import { examTemplatesLoad } from '../../../../itrust_common/redux/actions/settingActions/examTemplateActions';
import Alert from '../../../../itrust_common/components/Alert';

function ExamHeaderForm(props) {
  const { defaultVisible, handleSubmit, examTemplates, exam, selectedExamId, selectedExamTemplateId, providers, patient, currentUserRole, templateSwitchSaving, examViewModern, handleScrollToExamModules, showFindingField } = props;
  const dispatch = useDispatch();


  const handleExamEdit = (id) => {
    dispatch(examEdit(id));
    dispatch(examLoad(id, { include: '*' }));
  };

  useEffect(() => {
    if (exam.id) {
      dispatch(examTemplatesLoad({ sort: 'settings_exam_templates.position', direction: "asc", rpp: 9999, filter: { store_id: exam.store_id, staff_id: exam.staff_id, is_visible: true }, exam_listing: true }));
    }
  }, [exam.id, exam.staff_id]);

  useEffect(() => {
    const firstTab = getTemplateSupportedField(exam.template);
    dispatch(tabChange({ exam: examViewModern ? firstTab : 1 }));
    handleScrollToExamModules();
  }, [exam.settings_exam_template_id]);

  const handleTemplateChange = (value) => {
    if (String(value) === String(selectedExamTemplateId)) return;

    Alert.templateChange(
      'You are changing the exam template. How would you like to handle the existing exam data?',
      (mode) => {
        if (!mode) return;

        dispatch(examTemplateSwitched(true));
        dispatch(change('examHeaderForm', 'settings_exam_template_id', value));
        dispatch(change('examHeaderForm', 'template_change_mode', mode === 'replace_with_defaults' ? 'replace_with_defaults' : undefined));

        setTimeout(() => dispatch(submit('examHeaderForm')), 500);
      }
    );
  };

  const handleExamProviderChange = () => {
    dispatch(examTemplateSwitched(true));
    setTimeout(() => dispatch(submit("examHeaderForm")), 500);
  };

  const handleExamDateChange = () => {
    setTimeout(() => dispatch(submit('examHeaderForm')), 500);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="panel-group" id="accordion">
        <div className="panel panel-default">
          <div id="collapseOne" className={`panel-collapse collapse ${defaultVisible ? 'show' : ''}`}>
            <div className="panel-body">
              <div className="bg-white w-100 d-flex rounded shadow-sm my-5">
                <ExamPatientInfo patient={exam.patient_attributes} />
                <div className="border-left border-light p-5 w-100">
                  <div className="row">
                    <div className="col-4">
                      {showFindingField ?
                        <AutoCodeChiefComplaint showFindingField={showFindingField} /> :
                        <Field
                          name="hpis_attributes[0][chief_complaint]"
                          rows={3}
                          label="Chief Complaint"
                          component={Textarea}
                          className="form-control"
                          wrapperClasses="form-group"
                          onBlur={() => setTimeout(() => dispatch(submit("examHeaderForm")), 500)}
                          disabled={(currentUserRole === 'non_admin' && exam.status === "finalized") ? true : false}
                        />
                      }
                    </div>

                    <div className="col-2">
                      <Field
                        name="staff_id"
                        valueField="id"
                        textField="name"
                        data={providers}
                        label="Exam Provider"
                        hideResetButton={true}
                        supportAutoComplete={true}
                        displayName="provider_name"
                        wrapperClasses="form-group"
                        component={AutoCompleteSelect}
                        textFieldValue={exam.staff_attributes?.name ? `${exam.staff_attributes?.name} (Archived)` : ''}
                        onChangeHook={() => handleExamProviderChange()}
                        disabled={(currentUserRole === 'non_admin' && exam.status === "finalized") ? true : false}
                      />
                      <Field
                        name="recall_attributes.recall_reminder_date"
                        label="Recall Date"
                        component={DatePicker}
                        min={new Date()}
                        wrapperClasses="form-group"
                        onChangeHook={() => setTimeout(() => dispatch(submit("examHeaderForm")), 500)}
                        disabled={(currentUserRole === 'non_admin' && exam.status === "finalized") ? true : false}
                      />
                    </div>

                    <div className="col-2">
                      <div className="form-group">
                        <label htmlFor="formExamTemplaeSelection">Template Selection</label>
                        <select
                          className="form-control"
                          value={selectedExamTemplateId}
                          id="formExamTemplaeSelection"
                          onChange={(e) => handleTemplateChange(e.target.value)}
                          disabled={(currentUserRole === 'non_admin' && exam.status === "finalized") ? true : false}
                        >
                          {examTemplates.map((examTemplate) => <option key={examTemplate.id} value={examTemplate.id}>{examTemplate.name}</option>)}
                        </select>
                      </div>
                    </div>

                    <Field
                      name="exam_date"
                      label="Exam Date"
                      component={DateAndTimePicker}
                      wrapperClasses="form-group col-2"
                      validate={[required]}
                      onChangeHook={(e) => handleExamDateChange(e)}
                      disabled={(currentUserRole === 'non_admin' && exam.status === "finalized") ? true : false}
                    />

                    <div className="col-2">
                      <div className="form-group">
                        <label htmlFor="formExamSelection">Exam Selection</label>
                        <select className="form-control" value={selectedExamId} id="formExamSelection" onChange={(e) => handleExamEdit(e.target.value)}>
                          {exam.all_exams && exam.all_exams.map((exam) => <option key={exam.id} value={exam.id}><DateFormatView date={exam.exam_date} /></option>)}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DisabledLoader saving={templateSwitchSaving} wrapperClasses="full-screen-loader" />
    </form>
  );
}

ExamHeaderForm = reduxForm({
  form: 'examHeaderForm',
  enableReinitialize: true,
})(ExamHeaderForm);

ExamHeaderForm = connect(state => {
  const { currentStore, exam, setting: { orgConfig, examTemplate } } = state;

  return {
    exam: exam.exam,
    templateSwitchSaving: exam.templateSwitchSaving,
    providers: currentStore.staffs,
    examTemplates: examTemplate.exam_templates,
    selectedExamId: exam.editing && exam.editing.id,
    selectedExamTemplateId: exam.exam.settings_exam_template_id,
    examViewModern: orgConfig.org_config?.exam_settings.view_mode == 'modern',
    showFindingField: orgConfig.org_config?.exam_settings?.auto_diagnosis,
    initialValues: {
      id: exam.exam.id,
      provider_name: exam.exam.provider_name,
      staff_id: exam.exam.staff_id,
      exam_date: exam.exam.exam_date,
      hpis_attributes: exam.exam.hpis_attributes,
      recall_attributes: { recall_reminder_date: exam.exam?.patient_attributes?.recall_reminder_date },
      settings_exam_template_id: exam.exam.settings_exam_template_id
    }
  };
})(ExamHeaderForm);

export default ExamHeaderForm;